import React from 'react';
import PropTypes from 'prop-types';

export const EmptyChart = ({ i18n }) => (
  <div className="advisor-chart">
    <div className="chart-no-data-container">
      <span
        className="chart-no-data-label"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: i18n.getString('BI_Chart_NoData'),
        }}
      />
    </div>
  </div>
);

EmptyChart.displayName = 'EmptyChart';
EmptyChart.propTypes = {
  i18n: PropTypes.PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};
